import React, { useState } from 'react';
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    TextField,
    Typography,
} from '@mui/material';
import { useLogin, useNotify, Notification } from 'react-admin';

const apiUrl = process.env.REACT_APP_API_URL;

export const CustomLoginPage = () => {
    const login = useLogin();
    const notify = useNotify();

    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);

    const requestCode = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${apiUrl}/v1/accounts/code/email`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });
            if (!res.ok) throw new Error('Не удалось отправить код');
            notify('Код отправлен на email');
            setStep(2);
        } catch (err) {
            notify(err.message || 'Ошибка запроса кода', { type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login({ email, code });
        } catch (err) {
            notify(err.message || 'Ошибка входа', { type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
            <Card sx={{ width: 400 }}>
                <CardContent>
                    <Typography variant="h5" textAlign="center" gutterBottom>
                        Вход в админку
                    </Typography>
                    <form onSubmit={step === 1 ? (e) => { e.preventDefault(); requestCode(); } : handleLogin}>
                        <TextField
                            fullWidth
                            label="Email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            margin="normal"
                            required
                            autoFocus
                        />
                        {step === 2 && (
                            <TextField
                                fullWidth
                                label="Код из письма"
                                type="text"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                margin="normal"
                                required
                            />
                        )}
                        <CardActions sx={{ justifyContent: 'center', mt: 2 }}>
                            <Button type="submit" variant="contained" color="primary" disabled={loading}>
                                {step === 1 ? 'Отправить код' : 'Войти'}
                            </Button>
                        </CardActions>
                    </form>
                </CardContent>
            </Card>
            <Notification />
        </Box>
    );
};
